import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {CloseIcon} from "@pg-design/icons-module";
import {useUserDevice} from "@pg-mono/user-device";

import {useAppDispatch, useAppSelector} from "../../store/hooks";
import {closeSemanticSearchModal} from "../state/semantic_search_modal_slice";
import {SemanticSearchView} from "../view/SemanticSearchView";
import {SemanticSearchAuthOverlay} from "./semantic_search_auth/SemanticSearchAuthOverlay";
import {SemanticSearchFullscreenOverlay} from "./SemanticSearchFullscreenOverlay";

export const SemanticSearchModal = () => {
    const dispatch = useAppDispatch();
    const isSemanticSearchOpen = useAppSelector((state) => state.semanticSearchModal.isSemanticSearchOpen);
    const {isMobile} = useUserDevice();

    const onClose = () => {
        dispatch(closeSemanticSearchModal());
    };

    return (
        <>
            <SemanticSearchFullscreenOverlay isOpen={isSemanticSearchOpen} onClose={onClose}>
                {(overlayRef) => (
                    <>
                        <button type="button" onClick={onClose} aria-label="Zamknij" className={closeButtonMobile}>
                            <CloseIcon size="2" />
                        </button>

                        <Button
                            iconRight={CloseIcon}
                            className={closeButtonDesktop}
                            type="button"
                            variant="outlined_secondary"
                            size="small"
                            onClick={onClose}
                            aria-label="Zamknij"
                        >
                            ZAMKNIJ
                        </Button>

                        <SemanticSearchView containerRef={overlayRef} />
                    </>
                )}
            </SemanticSearchFullscreenOverlay>

            {isMobile && <SemanticSearchAuthOverlay usePortal />}
        </>
    );
};

const closeButtonMobile = css({
    position: "fixed",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    top: 0,
    right: 0,
    width: "44px",
    height: "44px",
    border: "none",
    background: "var(--colors-background-100)",
    cursor: "pointer",
    zIndex: 2,
    borderRadius: "50%",

    lg: {
        display: "none"
    }
});

const closeButtonDesktop = css({
    position: "fixed",
    top: 90,
    left: 120,
    zIndex: 1,
    display: "none",

    lg: {
        display: "inline-flex"
    }
});
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {CloseIcon} from "@pg-design/icons-module";
import {useUserDevice} from "@pg-mono/user-device";

import {useAppDispatch, useAppSelector} from "../../store/hooks";
import {closeSemanticSearchModal} from "../state/semantic_search_modal_slice";
import {SemanticSearchView} from "../view/SemanticSearchView";
import {SemanticSearchAuthOverlay} from "./semantic_search_auth/SemanticSearchAuthOverlay";
import {SemanticSearchFullscreenOverlay} from "./SemanticSearchFullscreenOverlay";

export const SemanticSearchModal = () => {
    const dispatch = useAppDispatch();
    const isSemanticSearchOpen = useAppSelector((state) => state.semanticSearchModal.isSemanticSearchOpen);
    const {isMobile} = useUserDevice();

    const onClose = () => {
        dispatch(closeSemanticSearchModal());
    };

    return (
        <>
            <SemanticSearchFullscreenOverlay isOpen={isSemanticSearchOpen} onClose={onClose}>
                {(overlayRef) => (
                    <>
                        <button type="button" onClick={onClose} aria-label="Zamknij" className={closeButtonMobile}>
                            <CloseIcon size="2" />
                        </button>

                        <Button
                            iconRight={CloseIcon}
                            className={closeButtonDesktop}
                            type="button"
                            variant="outlined_secondary"
                            size="small"
                            onClick={onClose}
                            aria-label="Zamknij"
                        >
                            ZAMKNIJ
                        </Button>

                        <SemanticSearchView containerRef={overlayRef} />
                    </>
                )}
            </SemanticSearchFullscreenOverlay>

            {isMobile && <SemanticSearchAuthOverlay usePortal />}
        </>
    );
};

const closeButtonMobile = css({
    position: "fixed",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    top: 0,
    right: 0,
    width: "44px",
    height: "44px",
    border: "none",
    background: "var(--colors-background-100)",
    cursor: "pointer",
    zIndex: 2,
    borderRadius: "50%",

    lg: {
        display: "none"
    }
});

const closeButtonDesktop = css({
    position: "fixed",
    top: 90,
    left: 120,
    zIndex: 1,
    display: "none",

    lg: {
        display: "inline-flex"
    }
});
